(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('UserChangePasswordController', UserChangePasswordController);

    UserChangePasswordController.$inject = ['$scope', 'UserService', 'UserData'];

    function UserChangePasswordController($scope, UserService, UserData) {
        var vm = this;
        vm.requestRunning = false;

        vm.groupName = UserData.groupName;

        vm.close = function () {
            if (!vm.requestRunning) {
                $scope.$emit('closeModalPassword');
            }
        }

        vm.save = function () {
            if (vm.formChangePassword.$valid && !vm.requestRunning && comparePassword()) {
                vm.requestRunning = true;
                UserService.changePassword(vm.changePassword).then(cbSuccess).catch(cbError);
            }
            function cbSuccess() {
                vm.requestRunning = false;
                UserService.successModalConstructor('changePassword');
                clearForm();
                $scope.$emit('closeModalPassword');
            }
            function cbError(response) {
                vm.requestRunning = false;
                UserService.errorModalConstructor(response, 'changePassword');
            }
        }

        // private methods
        function initModelChangePassword() {
            vm.changePassword = {
                id: UserData.id,
                password: '',
                newPassword: '',
                confirmNewPassword: ''
            };
        }

        function clearForm() {
            vm.formChangePassword.$setPristine();
            initModelChangePassword();
        }

        function comparePassword() {
            return vm.changePassword.newPassword == vm.changePassword.confirmNewPassword;
        }

        function initialize() {
            initModelChangePassword();
        }
        initialize();

    }
})();